import { render, staticRenderFns } from "./Register.view.vue?vue&type=template&id=6795bcc2&"
import script from "./Register.view.vue?vue&type=script&lang=js&"
export * from "./Register.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports